export default {"src":"/_next/static/media/picking-fruit.colour.4f115cac.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};